// extracted by mini-css-extract-plugin
export var circle = "_bs-1";
export var exitConfirmationModal = "_bs-5";
export var iframe = "_bs-0";
export var offline = "_bs-3";
export var online = "_bs-2";
export var workstationSelectError = "_bs-4";